// Vendor
import { CommonModule } from '@angular/common';
// Modules
import { ConfigModule } from 'NewAngular/config/config.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { PaginationControlsModule } from 'NewAngular/features/components/pagination/pagination-controls/pagination-controls.module';
import * as i0 from "@angular/core";
export class FlattenedHoldingsTableModule {
}
FlattenedHoldingsTableModule.ɵfac = function FlattenedHoldingsTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlattenedHoldingsTableModule)(); };
FlattenedHoldingsTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FlattenedHoldingsTableModule });
FlattenedHoldingsTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        FeatureNeededModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        PaginationControlsModule] });
